// Dynamic Diesels — Mobile nav drawer.
// Hamburger opens right-side drawer. Backdrop click, X button, or Escape close.
// Body scroll locks while open. Parent nav items accordion-open child collections.

(function () {
  'use strict';

  function init() {
    const drawer = document.querySelector('.dd-drawer');
    const hamburger = document.querySelector('.dd-nav__hamburger');
    if (!drawer || !hamburger) return;

    const closeBtn = drawer.querySelector('.dd-drawer__close');

    hamburger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    // Click the dimmed area left of the panel (or anywhere outside it) to close.
    drawer.addEventListener('click', (e) => {
      if (!e.target.closest('.dd-drawer__panel')) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Accordion: parent items expand child collections instead of navigating.
    drawer.querySelectorAll('[data-drawer-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.dd-drawer__item');
        if (!item) return;
        const opening = !item.classList.contains('is-open');

        drawer.querySelectorAll('.dd-drawer__item.is-open').forEach((openItem) => {
          if (openItem !== item) collapseItem(openItem);
        });

        if (opening) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        } else {
          collapseItem(item);
        }
      });
    });

    // Close on real navigation (child collections, resources, logo, etc.).
    drawer.querySelectorAll('.dd-drawer a').forEach((link) => {
      link.addEventListener('click', close);
    });

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dd-drawer-open');
      document.body.style.overflow = 'hidden';
      hamburger.setAttribute('aria-expanded', 'true');
    }

    function collapseItem(item) {
      item.classList.remove('is-open');
      const toggle = item.querySelector('[data-drawer-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dd-drawer-open');
      document.body.style.overflow = '';
      hamburger.setAttribute('aria-expanded', 'false');
      drawer.querySelectorAll('.dd-drawer__item.is-open').forEach(collapseItem);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
